import { Link } from 'react-router-dom'
import { Trophy, Mail, Phone, FileText } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#1A1A1A] text-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/kiniela_logo.png" 
                alt="Kiniela.mx Logo" 
                className="h-10 w-auto object-contain"
              />
              <span className="text-2xl font-bold text-[#D4AF37]">Kiniela.mx</span>
            </div>
            <p className="text-sm mb-4">
              La plataforma líder de pronósticos deportivos en México. Demuestra tu conocimiento
              del fútbol y gana premios.
            </p>
            <p className="text-xs text-[#F8F8F8]/70">
              Juego responsable. Mayores de 18 años.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#D4AF37] font-semibold mb-4">Enlaces</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/quinielas" className="hover:text-[#D4AF37] transition">
                  Quinielas
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-[#D4AF37] transition">
                  Mi Cuenta
                </Link>
              </li>
              <li>
                <a href="#faq" className="hover:text-[#D4AF37] transition">
                  Preguntas Frecuentes
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="hover:text-[#D4AF37] transition">
                  Cómo Funciona
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h3 className="text-[#D4AF37] font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terminos" className="flex items-center space-x-2 hover:text-[#D4AF37] transition">
                  <FileText size={14} />
                  <span>Términos y Condiciones</span>
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="flex items-center space-x-2 hover:text-[#D4AF37] transition">
                  <FileText size={14} />
                  <span>Política de Privacidad</span>
                </Link>
              </li>
              <li>
                <a
                  href="mailto:soporte@kiniela.mx"
                  className="flex items-center space-x-2 hover:text-[#D4AF37] transition"
                >
                  <Mail size={14} />
                  <span>Contacto</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#0F3D2E] mt-8 pt-8 text-sm text-center">
          <p>&copy; {currentYear} Kiniela.mx. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  )
}
